export const subjectLimit: Readonly<number> = 100;
export const descriptionLimit: Readonly<number> = 500;
export const basicFieldLimit: Readonly<number> = 50;
export const gidMaxLength: Readonly<number> = 8;

export const projectPrefix: Readonly<string> = 'shs-gbr-ema';

export const defaultTimezone: Readonly<string> = 'Europe/Berlin';
